import { call, put } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { requestScreenshareWhiteboardData } from 'features/content-whiteboard/actions';
import { contentBoard } from 'features/content-whiteboard/utils/contentBoardStateManager';
import { loaderDisplayChanged } from 'features/content-library/contentLibrarySlice';

export function* requestScreenshareWhiteboardDataSaga(
  action: ReturnType<typeof requestScreenshareWhiteboardData>
) {
  yield put(loaderDisplayChanged(true));

  const { feedId, userId } = action.payload;

  contentBoard.type = 'screenshare';
  contentBoard.id = feedId;
  contentBoard.screenshareUserId = userId;
  contentBoard.currentPage = 0;

  yield call(SignalingSocket.send, {
    event: 'requestScreenshareWhiteboardData',
    data: { feedId, userId },
  });
}
